"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueFormula = exports.FormulaSchema = void 0;
const zod_1 = require("zod");
const FormulaArgumentSchema = zod_1.z.lazy(() => zod_1.z.object({
    name: zod_1.z.string().nullable().optional(),
    isFunction: zod_1.z.boolean().nullable().optional(),
    formula: exports.FormulaSchema,
    type: zod_1.z.unknown().optional(),
    testValue: zod_1.z.unknown().optional(),
}));
exports.FormulaSchema = zod_1.z.lazy(() => zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('path'),
        path: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('function'),
        name: zod_1.z.string().min(1),
        displayName: zod_1.z.string().nullable().optional(),
        package: zod_1.z.string().nullable().optional(),
        arguments: zod_1.z.array(FormulaArgumentSchema).nullable().optional(),
        variableArguments: zod_1.z.boolean().nullable().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('record'),
        entries: zod_1.z.array(FormulaArgumentSchema).nullable().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('object'),
        arguments: zod_1.z.array(FormulaArgumentSchema).nullable().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('array'),
        arguments: zod_1.z
            .array(zod_1.z.object({ formula: exports.FormulaSchema }))
            .nullable()
            .optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('or'),
        arguments: zod_1.z
            .array(zod_1.z.object({ formula: exports.FormulaSchema }))
            .nullable()
            .optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('and'),
        arguments: zod_1.z
            .array(zod_1.z.object({ formula: exports.FormulaSchema }))
            .nullable()
            .optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('apply'),
        name: zod_1.z.string().min(1),
        arguments: zod_1.z.array(FormulaArgumentSchema).nullable().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('value'),
        value: zod_1.z.unknown().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('switch'),
        cases: zod_1.z
            .array(zod_1.z.object({
            condition: exports.FormulaSchema,
            formula: exports.FormulaSchema,
        }))
            .nullable()
            .optional(),
        default: exports.FormulaSchema,
    }),
]));
const valueFormula = (value) => ({
    type: 'value',
    value,
});
exports.valueFormula = valueFormula;
